/* Price presentation only. Native Shopify product-form owns every purchase action. */
if (!customElements.get('divine-purchase-price')) {
  customElements.define('divine-purchase-price', class extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      this.info = this.closest('product-info');
      this.button = this.closest('.product-form__submit');
      this.form = this.closest('form');
      if (!this.info || !this.button || !this.form) { this.hidden = true; return; }
      this.active = true;
      this.variant = this.variant || {
        id: this.dataset.variantId,
        price: Number(this.dataset.unitPrice),
        available: true
      };
      this.pending = false;
      this.onInput = () => this.refresh();
      this.info.addEventListener('input', this.onInput);
      this.info.addEventListener('change', this.onInput);
      this.unsubscribe = [];
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe.push(subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
          if (!data || String(data.sectionId) !== String(this.dataset.sectionId)) return;
          this.variant = data.variant || null;
          this.pending = false;
          this.refresh();
        }));
        this.unsubscribe.push(subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data } = {}) => {
          if (!data?.event?.target || !this.info.contains(data.event.target)) return;
          this.pending = true;
          this.refresh();
        }));
        if (PUB_SUB_EVENTS.quantityUpdate) {
          this.unsubscribe.push(subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.refresh()));
        }
      }
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this.info, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'value', 'class', 'min', 'max', 'step']
      });
      this.refresh();
    }

    disconnectedCallback() {
      this.active = false;
      this.info?.removeEventListener('input', this.onInput);
      this.info?.removeEventListener('change', this.onInput);
      this.unsubscribe?.forEach(unsubscribe => { if (typeof unsubscribe === 'function') unsubscribe(); });
      this.unsubscribe = [];
      this.observer?.disconnect();
      this.observer = null;
    }

    refresh() {
      if (!this.active) return;
      const id = this.form.querySelector('input[name="id"]');
      const quantityInput = Array.from(this.info.querySelectorAll('input[name="quantity"]')).find(input =>
        input.getAttribute('form') === this.form.id || input.closest('form') === this.form
      );
      const quantity = Number(quantityInput?.value ?? 1);
      const variant = this.variant;
      const price = Number(variant?.price);
      // Shopify volume prices can also depend on existing cart quantities. Leave them to native pricing.
      const volumePricing = this.info.querySelector('price-per-item') ||
        (Array.isArray(variant?.quantity_price_breaks) && variant.quantity_price_breaks.length > 0);
      const sellingPlan = this.form.querySelector('[name="selling_plan"]')?.value;
      const valid = !this.pending && variant && variant.available !== false && id && !id.disabled &&
        String(id.value) === String(variant.id) && !this.button.disabled &&
        this.button.getAttribute('aria-disabled') !== 'true' && !this.button.classList.contains('loading') &&
        Number.isSafeInteger(quantity) && quantity > 0 && Number.isSafeInteger(price) && price >= 0 &&
        Number.isSafeInteger(price * quantity) && !volumePricing && !sellingPlan;
      if (!valid) { this.hidden = true; return; }
      let money;
      try {
        money = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'en', {
          style: 'currency', currency: this.dataset.currency || 'USD'
        }).format(price * quantity / 100);
      } catch (_) { this.hidden = true; return; }
      const text = ` — ${money}`;
      if (this.textContent !== text) this.textContent = text;
      this.hidden = false;
    }
  });
}
